// extracted by mini-css-extract-plugin
module.exports = {"IconLink":"IconLink_IconLink__ByPOU","IconLinkSVG":"IconLink_IconLinkSVG__BGVrl","IconLinkSVGExternal":"IconLink_IconLinkSVGExternal__3cvOt"};